export const termsHero = {
  title: '利用規約',
  titleEn: 'TERMS OF SERVICE',
  lead: '本規約は、一般社団法人全日本執事協会（以下「当協会」）が運営する日本執事アカデミーのウェブサイトおよび関連サービスの利用条件を定めるものです。',
};

export interface TermsArticle {
  id: string;
  number: number;
  title: string;
  content: string[];
}

export const termsArticles: TermsArticle[] = [
  {
    id: 'article-01',
    number: 1,
    title: '適用範囲',
    content: [
      '本規約は、一般社団法人全日本執事協会（以下「当協会」といいます）が運営する「日本執事アカデミー」のウェブサイト（以下「本サイト」といいます）および本サイトを通じて提供される関連サービス（以下「本サービス」といいます）の利用に関し、当協会と利用者（以下「利用者」といいます）との間に適用されます。',
      '利用者は、本サイトを利用することにより、本規約の内容に同意したものとみなされます。本規約に同意いただけない場合は、本サイトのご利用をお控えください。',
    ],
  },
  {
    id: 'article-02',
    number: 2,
    title: '定義',
    content: [
      '本規約において使用する用語の定義は、以下のとおりとします。',
      '「本サイト」：当協会が運営する日本執事アカデミーのウェブサイト（https://butler-academy.jp）をいいます。',
      '「本サービス」：本サイトを通じて提供される情報提供、資料請求、個別相談の受付、各種お申込み受付、お問い合わせ対応その他のサービスをいいます。',
      '「受講生」：当協会が提供する講座を受講する方をいいます。',
      '「利用者」：本サイトを閲覧または利用するすべての方をいいます。',
    ],
  },
  {
    id: 'article-03',
    number: 3,
    title: '本サイトの利用',
    content: [
      '利用者は、本サイトを自己の責任において利用するものとします。',
      '当協会は、本サイトの利用に必要な機器・ソフトウェア・通信環境等について、一切の関与を行いません。',
      '当協会は、利用者に事前の通知なく、本サイトの内容の変更または運営の中断・中止を行うことができるものとします。',
      '本サイトの利用に関連して、利用者間または利用者と第三者との間に生じた紛争については、利用者が自己の責任と費用において解決するものとし、当協会は一切の責任を負いません。',
    ],
  },
  {
    id: 'article-04',
    number: 4,
    title: '知的財産権',
    content: [
      '本サイトに掲載される文章、画像、動画、ロゴ、教材、デザイン、プログラム、その他一切のコンテンツ（以下「本コンテンツ」といいます）に関する著作権、商標権その他の知的財産権は、当協会または正当な権利を有する第三者に帰属します。',
      '利用者は、本コンテンツを、当協会の事前の書面による承諾なく、複製、転載、改変、翻案、公衆送信、頒布、貸与、翻訳、販売その他方法の如何を問わず利用することを禁じます。',
      '本条の規定に違反して第三者との間に紛争が生じた場合、利用者は自己の責任と費用において解決するものとし、当協会に損害を与えた場合はその損害を賠償するものとします。',
    ],
  },
  {
    id: 'article-05',
    number: 5,
    title: '禁止事項',
    content: [
      '利用者は、本サイトの利用にあたり、以下の行為を行ってはならないものとします。',
      '（1）法令または公序良俗に反する行為',
      '（2）当協会または第三者の権利（知的財産権、名誉、プライバシー等）を侵害する行為',
      '（3）他の利用者、第三者または当協会になりすます行為',
      '（4）本サイトの運営を妨害する行為（大量アクセス、不正プログラムの送信等）',
      '（5）当協会の信用を毀損する行為',
      '（6）営利を目的とした情報の収集・利用',
      '（7）その他、当協会が不適切と判断する行為',
      '当協会は、利用者が本条に違反した場合、当該利用者に対し本サイトの利用停止その他の措置を講じることができるものとします。',
    ],
  },
  {
    id: 'article-06',
    number: 6,
    title: '受講契約との関係',
    content: [
      '本規約は、本サイトおよび本サービスの利用条件を定めるものであり、講座の受講契約そのものを定めるものではありません。',
      '講座のお申込み、受講、キャンセル、返金等の条件については、別途定める募集要項および受講契約によります。詳細は応募資格・申込の流れのページ（/application）をご参照ください。',
      '本規約の定めと受講契約の定めとの間に齟齬がある場合は、受講契約の定めが優先して適用されるものとします。',
    ],
  },
  {
    id: 'article-07',
    number: 7,
    title: '免責事項',
    content: [
      '当協会は、本サイトに掲載する情報の正確性、最新性、有用性について細心の注意を払いますが、その完全性を保証するものではありません。',
      '本サイトの利用により生じたいかなる損害（間接損害、特別損害、逸失利益を含みます）についても、当協会の故意または重過失による場合を除き、当協会は責任を負いません。',
      '本サイトからリンクされた第三者のウェブサイトの内容について、当協会は一切の責任を負いません。',
      '当協会は、天災、回線障害、機器故障、保守作業その他やむを得ない事由により、本サービスの提供を一時的に中断できるものとし、これにより利用者に損害が生じた場合も、当協会の故意または重過失による場合を除き責任を負いません。',
    ],
  },
  {
    id: 'article-08',
    number: 8,
    title: 'サービスの変更・中断',
    content: [
      '当協会は、利用者に事前の通知なく、本サービスの内容を変更、追加、または廃止することができるものとします。',
      '当協会は、以下のいずれかに該当する場合、本サービスの全部または一部を一時的に中断することがあります。',
      '（1）本サイトの保守・点検を行う場合',
      '（2）天災、停電、通信回線の障害その他不測の事態により本サービスの提供が困難な場合',
      '（3）その他、当協会が運用上または技術上一時的な中断が必要と判断した場合',
      '当協会は、前項に基づく変更・中断により利用者に損害が生じた場合であっても、当協会の故意または重過失による場合を除き責任を負いません。',
    ],
  },
  {
    id: 'article-09',
    number: 9,
    title: '準拠法および裁判管轄',
    content: [
      '本規約の解釈および適用は、日本国法を準拠法とします。',
      '本サービスに関連して当協会と利用者との間に紛争が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。',
    ],
  },
  {
    id: 'article-10',
    number: 10,
    title: '規約の変更',
    content: [
      '当協会は、以下のいずれかに該当する場合、本規約を変更することができるものとします。',
      '（1）本規約の変更が利用者の一般の利益に適合するとき',
      '（2）本規約の変更が、契約をした目的に反せず、かつ変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき',
      '当協会は、本規約を変更する場合、変更後の規約の内容および効力発生日を本サイト上に掲載することにより周知します。重要な変更については、資料請求者および受講生の皆様へメール等で個別にご案内する場合があります。',
      '変更後の規約は、効力発生日以降、本サイトの継続利用をもって、利用者が変更後の規約に同意したものとみなします。',
    ],
  },
];

export const termsRelatedLinks = [
  {
    label: 'プライバシーポリシー',
    href: '/privacy',
    description: '個人情報の取扱い方針について定めています。',
  },
  {
    label: '特定商取引法に基づく表記',
    href: '/commercial-law',
    description: '特定商取引に関する法律に基づく表示事項です。',
  },
  {
    label: 'お問い合わせ',
    href: '/contact',
    description: 'ご質問やご不明な点はこちらからお問い合わせください。',
  },
];